import React, { useMemo, useState } from 'react';
import { alpha, Icon, ListItem, ListItemText } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import AppNavLink from '../../../AppNavLink';
import Badge from '@mui/material/Badge';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { useLocation } from 'react-router-dom';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { checkPermission } from '@crema/utility/helper/RouteHelper';
import ModalInformasi from '../ModalInformasi';
import * as Icons from '@mui/icons-material';
import { COLORS } from 'shared/constants/AppEnums';

const checkAccess = (userRoles, menuRoles) => {
    let permit = false;
    for (const value of menuRoles) {
        if (userRoles.includes(value)) {
            permit = true;
            break;
        }
    }
    return permit;
};


function HorizontalModal(props) {

    const { item, dense } = props;
    const { user } = useAuthUser();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const active = isUrlInChildren(item, location.pathname);
    const { sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor } =
        useSidebarContext();

    const hasPermission = useMemo(
        () => checkPermission(item.permittedRole, user.role),
        [item.permittedRole, user.role],
    );
    if (!hasPermission) {
        return null;
    }

    if (user.roles_access.includes('CRSFE_ADMIN_PENOMORAN')) {
        if (item.id === 'app-portal') return null;
    }

    if (item.role_access) {
        const roleAccess = checkAccess(user.roles_access, item.role_access);
        if (!roleAccess) return null;
    }

    function isUrlInChildren(parent, url) {
        if (!parent.children) {
            return false;
        }

        for (let i = 0; i < parent.children.length; i++) {
            if (parent.children[i].children) {
                if (isUrlInChildren(parent.children[i], url)) {
                    return true;
                }
            }

            if (
                parent.children[i].url === url ||
                url.includes(parent.children[i].url)
            ) {
                return true;
            }
        }

        return false;
    }

    const handleClick = (state) => {
        setOpen(state);
    };

    let toProps = {
    }

    const IconComponent = Icons[item?.icon];

    return (
        <>
            <ListItem
                component={AppNavLink}
                activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : ''}
                className={clsx('navItemSubmenu', dense && 'dense')}
                exact={item.exact}
                onClick={() => handleClick(true)}
                {...toProps}
                sx={{
                    minHeight: 40,
                    padding: '4px 12px',
                    color: (theme) => theme.palette.text.primary,
                    textDecoration: 'none!important',
                    minWidth: 160,
                    '&.active': {
                        // backgroundColor: sidebarMenuSelectedBgColor,
                        // color: sidebarMenuSelectedTextColor + '!important',
                        backgroundColor: `${alpha(COLORS.primary, 0.2)} !important`,
                        color: `${COLORS.primary} !important`,
                        pointerEvents: 'none',
                        '& .list-item-text-primary': {
                            color: 'inherit',
                        },
                        '& .list-item-icon': {
                            color: 'inherit',
                        },
                    },
                    '& .list-item-text': {
                        padding: '0 0 0 16px',
                    },
                    '&.dense': {
                        padding: '4px 12px',
                        minHeight: 40,
                        '& .list-item-text': {
                            padding: '0 0 0 8px',
                        },
                    },
                }}
            >
                {item.icon && (
                    <Icon
                        sx={{
                            color: active ? COLORS.primary : 'action',
                            mr: 3,
                            fontSize: { xs: 16, xl: 18 },
                        }}
                    >
                        <IconComponent sx={{ fontSize: '20px' }} />
                    </Icon>
                )}
                <ListItemText
                    className='AppNavLinkTextSubmenu'
                    primary={item.messageId}
                />
                {item.count && (
                    <Box ml={4}>
                        <Badge
                            count={item.count}
                            sx={{
                                color: item.color,
                            }}
                        />
                    </Box>
                )}
            </ListItem>

            <ModalInformasi
                open={open}
                handleClose={handleClick}
            />
        </>
    );
}

HorizontalModal.defaultProps = {};

export default React.memo(HorizontalModal);

HorizontalModal.propTypes = {
    item: PropTypes.object,
    location: PropTypes.object,
    dense: PropTypes.bool,
};
